import { useQuery } from '@apollo/client';
import { useCurrentAccount } from '@application/api';
import { graphql } from '@gql/gql';
import { SortOrder } from '@gql/graphql';

export const APPLICATION_GET_LATEST_APPLICATION = graphql(`
  query ApplicationGetLatestApplication(
    $where: DogBreederApplicationWhereInput
    $take: Int
    $orderBy: DogBreederApplicationOrderByWithRelationAndSearchRelevanceInput
  ) {
    accountMe {
      id
      applications(where: $where, take: $take, orderBy: $orderBy) {
        id
        motive
        otherAnimals
        accommodation
        experiences
        timeAlone
        trainers
        genderPreferences
        otherPreferences
        status
        questions

        breedPreference {
          id
        }
      }
    }
  }
`);

export const useGetLatestApplication = (breederId?: number) => {
  const { currentAccountLoggedIn, currentAccountLoading } = useCurrentAccount();

  const { data, loading } = useQuery(APPLICATION_GET_LATEST_APPLICATION, {
    variables: {
      take: 1,
      orderBy: {
        createdAt: SortOrder.desc,
      },
      where: {
        archived: { equals: false },
        ...(breederId ? { dogBreederId: { equals: breederId } } : {}),
      },
    },
    ssr: false,
    fetchPolicy: 'no-cache',
    skip: !currentAccountLoggedIn,
  });

  return {
    application: data?.accountMe?.applications[0],
    applicationLoading: loading || currentAccountLoading,
  };
};
